export const palette = {
    GAIN: '#23DDB2',
    LOSS: '#FF430E'
}

export const light = {
    color: '#333',
    background: '#FFF'
}

export const dark = {
    color: '#FFF',
    background: '#121729'
}

const defaultExport = {
    palette,
    light,
    dark
}
export default defaultExport;
